import axios from "axios";

import { getHeader } from "../headers";

// ===================================================================================
//  GET PHONE TYPES
// ===================================================================================
export const languagesLoading = () => {
	return {
		type: "LANGUAGES_IS_LOADING"
	};
};

export const languagesError = err => {
	return {
		type: "LANGUAGES_HAS_ERROR",
		err
	};
};

export const languagesSuccess = data => {
	return {
		type: "LANGUAGES_SUCCESS",
		data
	};
};

export function getLanguages() {
	return dispatch => {
		dispatch(languagesLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + "languages", {
				headers: getHeader()
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(languagesError(response.data.errors));
				} else {
					dispatch(languagesSuccess(response.data));
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(languagesError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/languages.js